import { createVNode, createComponentVNode, createTextVNode } from "inferno";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { Component } from 'inferno';
import Input from 'dmn-js-shared/lib/components/Input';
import InputSelect from 'dmn-js-shared/lib/components/InputSelect';
var TYPE_REF_OPTIONS = [{
  label: 'string',
  value: 'string'
}, {
  label: 'boolean',
  value: 'boolean'
}, {
  label: 'integer',
  value: 'integer'
}, {
  label: 'long',
  value: 'long'
}, {
  label: 'double',
  value: 'double'
}, {
  label: 'date',
  value: 'date'
}];

var LiteralExpressionPropertiesComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(LiteralExpressionPropertiesComponent, _Component);

  function LiteralExpressionPropertiesComponent(props, context) {
    var _this;

    _classCallCheck(this, LiteralExpressionPropertiesComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LiteralExpressionPropertiesComponent).call(this, props, context));
    _this._viewer = context.injector.get('viewer');
    _this._modeling = context.injector.get('modeling');
    _this._expressionLanguages = context.injector.get('expressionLanguages');

    var decision = _this._viewer.getDecision();

    _this.state = {
      name: decision.variable.name,
      typeRef: decision.variable.typeRef,
      expressionLanguage: getExpressionLanguage(decision.literalExpression)
    };
    _this.setVariableName = _this.setVariableName.bind(_assertThisInitialized(_this));
    _this.setVariableType = _this.setVariableType.bind(_assertThisInitialized(_this));
    _this.setExpressionLanguage = _this.setExpressionLanguage.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LiteralExpressionPropertiesComponent, [{
    key: "setVariableName",
    value: function setVariableName(name) {
      this._modeling.editVariableName(name);

      this.setState({
        name: name
      });
    }
  }, {
    key: "setVariableType",
    value: function setVariableType(typeRef) {
      if (typeRef === '') {
        this._modeling.editVariableType(undefined);

        this.setState({
          typeRef: undefined
        });
      } else {
        this._modeling.editVariableType(typeRef);

        this.setState({
          typeRef: typeRef
        });
      }
    }
  }, {
    key: "setExpressionLanguage",
    value: function setExpressionLanguage(expressionLanguage) {
      if (expressionLanguage === '') {
        this._modeling.editExpressionLanguage(undefined);

        this.setState({
          expressionLanguage: undefined
        });
      } else {
        this._modeling.editExpressionLanguage(expressionLanguage);

        this.setState({
          expressionLanguage: expressionLanguage
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          expressionLanguage = _this$state.expressionLanguage,
          name = _this$state.name,
          typeRef = _this$state.typeRef;

      var languageOptions = this._expressionLanguages.getAll();

      return createVNode(1, "div", "literal-expression-properties", createVNode(1, "table", null, [createVNode(1, "tr", null, [createVNode(1, "td", null, createTextVNode("Variable Name:"), 2), createVNode(1, "td", null, createComponentVNode(2, Input, {
        "className": "variable-name-input",
        "onInput": this.setVariableName,
        "placeholder": 'name',
        "value": name || ''
      }), 2)], 4), createVNode(1, "tr", null, [createVNode(1, "td", null, createTextVNode("Variable Type:"), 2), createVNode(1, "td", null, createVNode(1, "div", "dms-fill-row", createComponentVNode(2, InputSelect, {
        "onChange": this.setVariableType,
        "options": TYPE_REF_OPTIONS,
        "value": typeRef,
        "className": "variable-type-select dms-block"
      }), 2), 2)], 4), createVNode(1, "tr", null, [createVNode(1, "td", null, createTextVNode("Expression Language:"), 2), createVNode(1, "td", null, createVNode(1, "div", "dms-fill-row", createComponentVNode(2, InputSelect, {
        "onChange": this.setExpressionLanguage,
        "options": languageOptions,
        "value": expressionLanguage,
        "className": "expression-language-select dms-block"
      }), 2), 2)], 4)], 4), 2);
    }
  }]);

  return LiteralExpressionPropertiesComponent;
}(Component); // helpers //////////////////////


export { LiteralExpressionPropertiesComponent as default };

function getExpressionLanguage(literalExpression) {
  return literalExpression && literalExpression.expressionLanguage ? literalExpression.expressionLanguage.toLowerCase() : undefined;
}
//# sourceMappingURL=LiteralExpressionPropertiesEditorComponent.js.map